import React from "react";
import { Reveal } from "./Reveal";
interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  subtitle?: string;
  align?: "left" | "center";
  invert?: boolean;
}
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = "center",
  invert = false
}: SectionHeadingProps) {
  return <Reveal className={(align === "center" ? "text-center mx-auto " : "text-left ") + "max-w-2xl"} data-id="element-286" data-mp="rwzoa5mujqnq">
      <span className="inline-flex items-center gap-2 text-orange font-semibold text-sm uppercase tracking-[0.18em]" data-id="element-287" data-mp="n0rez8vbyroh">
        <span className="h-px w-6 bg-orange" aria-hidden="true" data-id="element-288" data-mp="d8v3mw48h52b" />
        {eyebrow}
      </span>
      <h2 className={"mt-3 font-heading font-bold uppercase text-3xl sm:text-4xl lg:text-[2.75rem] leading-[1.05] " + (invert ? "text-white" : "text-navy")} data-id="element-289" data-mp="d6imgl6auyqb">
        {title}
      </h2>
      {subtitle && <p className={"mt-4 text-base sm:text-lg leading-relaxed " + (invert ? "text-slate-300" : "text-slate-600")} data-id="element-290" data-mp="3vfsyq9kbvzdo">
          {subtitle}
        </p>}
    </Reveal>;
}